import { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { xosoService } from "@/services/xosoService";
import { GAME_MEGA, GAME_ORDER, GAME_POWER } from "./constants";

dayjs.extend(utc);

const FETCHERS = {
  [GAME_MEGA]: (params) => xosoService.getMega645(params),
  [GAME_POWER]: (params) => xosoService.getPower655(params),
};

function drawDateKey(drawDate) {
  if (!drawDate) return null;
  const raw = String(drawDate);
  const d = /^\d{4}-\d{2}-\d{2}$/.test(raw) ? dayjs(raw) : dayjs.utc(raw);
  return d.isValid() ? d.format("YYYY-MM-DD") : null;
}

function sortResults(a, b) {
  const da = dayjs(a.drawDate).valueOf();
  const db = dayjs(b.drawDate).valueOf();
  if (db !== da) return db - da;
  return a.game === GAME_POWER ? 1 : -1;
}

function pickNearestDate(items) {
  return items.reduce((best, item) => {
    const key = drawDateKey(item.drawDate);
    if (!key) return best;
    return !best || key > best ? key : best;
  }, null);
}

export default function useVietlottResults(date, games = GAME_ORDER) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resolvedDate, setResolvedDate] = useState(date || null);
  const gamesKey = (games.length ? games : GAME_ORDER).join(",");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const list = gamesKey.split(",");

    (async () => {
      const params = date ? { date } : {};
      let items = (await Promise.all(list.map((game) => FETCHERS[game]?.(params)))).filter(Boolean);

      let nextDate = date || null;
      if (!date) {
        nextDate = pickNearestDate(items);
        items = nextDate ? items.filter((item) => drawDateKey(item.drawDate) === nextDate) : [];
      }

      items.sort(sortResults);

      if (!cancelled) {
        setResults(items);
        setResolvedDate(nextDate);
        setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [date, gamesKey]);

  return { results, loading, resolvedDate };
}
